import { Global } from '@emotion/react';
import { createInstance, HackleProvider } from '@hackler/react-sdk';
import { NotificationsProvider, reset, ThemeProvider } from '@inflearn/ds-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import type { ReactNode } from 'react';

import { CDN_URL, HACKLE_BROWSER_SDK_KEY } from './appConfig';
import globals from './styles/globals';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
      suspense: false,
    },
  },
});

const hackleClient = createInstance(HACKLE_BROWSER_SDK_KEY, {
  exposureEventDedupIntervalMillis: 1_000,
  pollingIntervalMillis: 30_000,
});

export default function AppProvider({ children }: { children: ReactNode }) {
  const user = {
    id: Cookies.get('deviceId'),
  };

  // reset props 에 해당 스타일을 적용하면, 앱쉘의 css 를 불러올 수 없어 주석 처리
  // const styles = {
  //   // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  //   '#for-ant-man': {
  //     ...reset,
  //   },
  // };

  return (
    <QueryClientProvider client={queryClient}>
      <HackleProvider hackleClient={hackleClient} user={user}>
        <ThemeProvider cdnLink={CDN_URL} withNormalizeCSS={false}>
          <NotificationsProvider />
          <Global styles={[globals]} />
          {children}
        </ThemeProvider>
      </HackleProvider>
    </QueryClientProvider>
  );
}
